import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'ProcessingAgencyManagers/GetProcessingAgencyForManager', method: 'GET', body: null, token: token })
}
